import {
  ApplicationConfig,
  LOCALE_ID,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http'
import { DatePipe, DecimalPipe } from '@angular/common'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter, withInMemoryScrolling } from '@angular/router'
import { provideEffects } from '@ngrx/effects'
import { provideStore } from '@ngrx/store'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  NativeDateAdapter,
} from '@angular/material/core'
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete'
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter'
import { routes } from './app.routes'
import { DatepickerFormat } from './core/config/datepicker.format'
import { AuthTokenInterceptor } from './core/interceptors/auth-token.interceptor'
import { TokenRefreshInterceptor } from './core/interceptors/token-refresh.interceptor'
import { ErrorInterceptor } from './core/interceptors/error.interceptor'
import { PaginacaoLoadingInterceptor } from './core/interceptors/paginacao-loading.interceptor'
import { provideTableEllipsis } from './core/directive/table-ellipsis.provider'
import { rootReducer } from './store'

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: PaginacaoLoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DatePipe,
    DecimalPipe,
    provideTableEllipsis(),

    provideZoneChangeDetection({
      eventCoalescing: false,
      runCoalescing: false,
    }),

    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),

    provideStore(rootReducer),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideEffects([]),

    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),

    {
      provide: DateAdapter,
      useClass: NativeDateAdapter,
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: DatepickerFormat },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: DatePipe },
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { autoActiveFirstOption: true },
    },
  ],
}
